import ProfileShareModal from '@/features/profile/ProfileShareModal';
import { useProfileShareStore } from '@/features/profile/profileShareStore';

export default function ProfileShareModalHost() {
  const isOpen = useProfileShareStore((state) => state.isOpen);
  const closeProfileShare = useProfileShareStore((state) => state.closeProfileShare);

  if (!isOpen) {
    return null;
  }

  return <ProfileShareModal onClose={closeProfileShare} />;
}
